import React, { useState, useEffect } from 'react'
import { toast, ToastContainer } from 'react-toastify'
import Header from '../header'
import Footer from '../NewFooter'
import { Grid, Typography, Button, Paper } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { useHistory, useLocation } from 'react-router-dom'
import Select from 'react-select'
import request, { client, NodeURL, SubdomainURL } from '../../../api/api'
import './findJobs.css'
import icon7 from '../../../images/Jobs/icon_7.svg'
import icon8 from '../../../images/Jobs/icon_8.svg'
import icon9 from '../../../images/Jobs/icon_9.svg'
import Arrow_icon from '../../../images/Jobs/Arrow.svg'
import { CheckValue } from '../../common/utils'
// import { BorderBottom } from '@mui/icons-material'

const useStyles = makeStyles(theme => ({
   container: {
      maxWidth: 1140,
      marginLeft: 'auto',
      marginRight: 'auto',
      backgroundColor: '#fff'
      // height: '2300px'
   },
   textBlock: {
      textAlign: 'center'
   },
   title: {
      fontSize: '50px',
      fontWeight: '700',
      color: '#1A202C',
      lineHeight: '64px',
      '& span': {
         fontWeight: '300',
         color: '#5F4B95'
      }
   },
   headline: {
      color: '#1A202C',
      fontSize: '18px',
      marginBottom: '0rem',
      lineHeight: '35px',
      fontWeight: '200'
   },
   subText: {
      fontWeight: '200',
      marginBottom: '1rem',
      color: '#555',
      lineHeight: '25px'
   },
   searchContainer: {
      display: 'flex',
      alignItems: 'end',
      justifyContent: 'center',
      gap: '20px',
      marginTop: '30px',
      flexWrap: 'wrap' // for responsive
   },
   fieldWrapper: {
      flex: '1 1 0',
      minWidth: '200px',
      maxWidth: '300px',
      width: '100%',
      '& label': {
         color: '#1A202C',
         fontSize: '14px'
      }
   },
   searchButton: {
      height: '46px', // same height
      padding: '0 30px',
      backgroundColor: '#5F4B95',
      color: '#fff',
      borderRadius: '8px',
      fontWeight: 600,
      fontSize: '16px',
      textTransform: 'none',
      whiteSpace: 'nowrap',
      border: 'none',
      borderBottom: '1px solid #ccc',
      '&:hover': {
         backgroundColor: '#5E1788'
      }
   },
   cardContainerOuter: {
      backgroundColor: '#F7FAFC',
      borderRadius: 16,
      marginTop: 35
   },
   cardOuterTitle: {
      fontSize: '18px',
      fontWeight: 600,
      margin: '10px 0px 10px 10px',
      color: '#4f5b67',
      textAlign: 'left',
      paddingTop: 10,
      paddingLeft: 10
   },
   cardContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '16px',
      marginBottom: '24px',
      // justifyContent: 'center',
      overflow: 'hidden',
      backgroundColor: '#F7FAFC',
      marginLeft: 30
   },

   icon: {
      width: 15,
      height: 15,
      margin: '10px 0px 10px 10px'
   },
   cardTitle: {
      fontSize: '20px',
      fontWeight: 600,
      margin: '10px 0px 10px 10px',
      color: '#1A202C'
   },
   cardText: {
      fontSize: '14px',
      color: '#4f5b67',
      margin: '10px 0px 10px 10px'
   },
   cardAlignment: {
      display: 'flex',
      height: 28
   },
   viewdetailbtn: {
      fontSize: 13,
      color: '#1D9BF0',
      margin: '10px 0px 10px 10px',
      cursor: 'pointer'
   },
   salaryContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      '& span': {
         color: '#1A202C',
         fontSize: '22px',
         fontWeight: 600
      }
   },

   applyButton: {
      border: '1px solid #1D9BF0',
      color: '#1D9BF0',
      marginRight: 15,
      height: 33,
      fontSize: 14,
      '& span': {
         color: '#1D9BF0',
         fontSize: 14,
         fontWeight: 400
      }
   },
   card: {
      backgroundColor: '#fff',
      borderRadius: 16,
      height: '330px',
      width: '256px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
      textAlign: 'left',
      marginBottom: 30,
      transition: 'background-color 0.3s ease',

      // target nested salaryContainer and span on hover
      '&:hover $salaryContainer': {
         '& span': {
            color: '#5F4B95'
         }
      },

      '&:hover $applyButton': {
         backgroundColor: '#1D9BF0 !important',
         color: '#fff !important',
         '& span': {
            color: '#fff !important'
         }
      },
      '@media (max-width: 1200px)': {
         width: '32%'
      },
      '@media (max-width: 840px)': {
         width: '48%'
      },
      '@media (max-width: 480px)': {
         width: '100%'
      }
   }
}))

const browseJobs = () => {
   const classes = useStyles()
   const domHistory = useHistory()
   const domLocation = useLocation()

   const [industryOptions, setIndustryOptions] = useState([])
   const [locationOptions, setLocationOptions] = useState([])
   const [jobTypeOptions, setJobTypeOptions] = useState([])
   const [selectedLocation, setSelectedLocation] = useState([])
   const [selectedIndustry, setSelectedIndustry] = useState([])
   const [selectedJobType, setSelectedJobType] = useState([])
   const [filteredDataList, setFilteredDataList] = useState([])
   const [filteredDataListCount, setFilteredDataListCount] = useState(null)
   const [agencyId, setAgencyId] = useState('')

   const returnedSearchFilters = domLocation && domLocation.state && domLocation.state.searchFilters ? domLocation.state.searchFilters : null

   const fetchOnIndustryData = async ({ agencyId }) => {
      let obj = {
         agencyId: agencyId || ''
      }

      try {
         let res = await request({
            url: '/site/jobs/industrytype',
            method: 'POST',
            data: obj
         })
         if (res && res.status === 1 && res.response.length > 0) {
            const uniqueData = res.response.reduce((acc, curr) => {
               if (!acc.some(item => item.value === curr.name)) {
                  acc.push({ label: curr.name, value: curr.name })
               }
               return acc
            }, [])
            setIndustryOptions(uniqueData || [])
         }
      } catch (err) {
         toast.error(err.message)
      }
   }

   const fetchOnLocationData = async ({ agencyId }) => {
      let obj = {
         agencyId: agencyId || ''
      }
      try {
         let res = await request({
            url: '/site/jobs/locationtype',
            method: 'POST',
            data: obj
         })
         if (res && res.status === 1 && res.response.length > 0) {
            const uniqueData = res.response.reduce((acc, curr) => {
               if (!acc.some(item => item.value === curr.name)) {
                  acc.push({ label: curr.name, value: curr.name })
               }
               return acc
            }, [])
            setLocationOptions(uniqueData || [])
         }
      } catch (err) {
         toast.error(err.message)
      }
   }

   const fetchOnJobRoleData = async ({ agencyId }) => {
      let obj = {
         agencyId: agencyId || ''
      }
      try {
         let res = await request({
            url: '/site/jobs/jobrole',
            method: 'POST',
            data: obj
         })
         if (res && res.status === 1 && res.response.length > 0) {
            const uniqueData = res.response.reduce((acc, curr) => {
               if (!acc.some(item => item.value === curr.name)) {
                  acc.push({ label: curr.name, value: curr.name })
               }
               return acc
            }, [])
            setJobTypeOptions(uniqueData || [])
         }
      } catch (err) {
         toast.error(err.message)
      }
   }

   const updateAgencyIdFromHash = () => {
      const hash = window.location.hash.substring(1)
      let industry =
         returnedSearchFilters && Array.isArray(returnedSearchFilters.selectedIndustry) && returnedSearchFilters.selectedIndustry.length > 0
            ? returnedSearchFilters.selectedIndustry
            : []
      let location =
         returnedSearchFilters && Array.isArray(returnedSearchFilters.selectedLocation) && returnedSearchFilters.selectedLocation.length > 0
            ? returnedSearchFilters.selectedLocation
            : []
      let jobType =
         returnedSearchFilters && Array.isArray(returnedSearchFilters.selectedJobType) && returnedSearchFilters.selectedJobType.length > 0
            ? returnedSearchFilters.selectedJobType
            : []

      setAgencyId(hash || '')
      setSelectedIndustry(industry)
      setSelectedLocation(location)
      setSelectedJobType(jobType)

      fetchOnJobSearch({ agencyId: hash || '', industry, location, jobType })
      fetchOnIndustryData({ agencyId: hash || '' })
      fetchOnLocationData({ agencyId: hash || '' })
      fetchOnJobRoleData({ agencyId: hash || '' })

      // Clear history state afterward
      // domHistory.replace({ state: null })
   }

   useEffect(() => {
      updateAgencyIdFromHash()
   }, [])

   const handleOnSelect = (selectedOptions, setState) => {
      setState(selectedOptions || [])
   }

   const fetchOnJobSearch = async ({ industry, location, jobType, agencyId }) => {
      try {
         let obj = {
            location: location ? location.map(item => item.value) : selectedLocation.map(item => item.value),
            industry: industry ? industry.map(item => item.value) : selectedIndustry.map(item => item.value),
            jobType: jobType ? jobType.map(item => item.value) : selectedJobType.map(item => item.value),
            agencyId: agencyId || ''
         }

         let res = await request({
            url: '/site/jobs/searchFilteredJobs',
            method: 'POST',
            data: obj
         })
         if (res && res.status === 1) {
            setFilteredDataList(res.response || [])
            setFilteredDataListCount(res.count || 0)
         }
         if (res.count === null) {
            setFilteredDataListCount(null)
         }
      } catch (err) {
         toast.error(err.message)
      }
   }

   const handleOnJobView = selectedJob => {
      const searchFilters = {
         selectedLocation,
         selectedIndustry,
         selectedJobType
      }

      const pushConfig = {
         pathname: '/jobs/browse/view',
         state: { selectedJob, searchFilters }
      }

      if (CheckValue(agencyId)) {
         pushConfig.hash = `#${agencyId}`
      }

      domHistory.push(pushConfig)
   }

   const handleOnJobsRedirect = data => {
      let subdomain = data && data.agencySubdomain ? data.agencySubdomain : data && data.agencySubdomain1 ? data.agencySubdomain1 : '';
      let query = {
         job_type: data && Array.isArray(data.jobRole) && data.jobRole.length > 0 ? data.jobRole.map(x => ({ label: x.name, value: x._id })) : [],
         industryType:
            data && Array.isArray(data.industryType) && data.industryType.length > 0 ? data.industryType.map(x => ({ label: x.name, value: x._id })) : [],
         locations:
            data && Array.isArray(data.locationType) && data.locationType.length > 0 ? data.locationType.map(x => ({ label: x.name, value: x._id })) : [],
         agencyId: agencyId || ''
      }
      if (!subdomain) return
      const protocol = NodeURL.split(':')[0]
      let host = protocol === 'http' ? 'localhost:3007' : SubdomainURL
      let URL = `${protocol}://${subdomain}.${host}/candidate/register`

      // query is string if we dont use the array turn to [object, object] that why we use this method
      const queryString = Object.keys(query)
         .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(JSON.stringify(query[key]))}`)
         .join('&')

      if (queryString) {
         URL += `?${queryString}`
      }

      window.location.href = URL
   }

   return (
      <>
         <Header />
         <ToastContainer position="top-right" autoClose={2500} closeOnClick />
         <div className={classes.container}>
            <div className={classes.textBlock}>
               <Typography className={classes.title}>
                  <span>Get Shifts</span> Recruitment
               </Typography>
               <Typography className={classes.headline}>Find Flexible Work Opportunities That Suit Your Schedule</Typography>
               <Typography className={classes.subText}>Join our platform and get matched with roles near you.</Typography>
            </div>
            <div className={classes.searchContainer}>
               <div className={classes.fieldWrapper}>
                  <label>Location</label>
                  <Select
                     isMulti={true}
                     className="findJob_Select"
                     options={locationOptions}
                     value={selectedLocation}
                     onChange={e => handleOnSelect(e, setSelectedLocation)}
                  />
               </div>
               <div className={classes.fieldWrapper}>
                  <label>Industry</label>
                  <Select
                     isMulti={true}
                     className="findJob_Select"
                     options={industryOptions}
                     value={selectedIndustry}
                     onChange={e => handleOnSelect(e, setSelectedIndustry)}
                  />
               </div>
               <div className={classes.fieldWrapper}>
                  <label>Job Role</label>
                  <Select
                     isMulti={true}
                     className="findJob_Select"
                     options={jobTypeOptions}
                     value={selectedJobType}
                     onChange={e => handleOnSelect(e, setSelectedJobType)}
                  />
               </div>
               <Button className={classes.searchButton} onClick={() => fetchOnJobSearch({ agencyId })}>
                  Search
               </Button>
            </div>
            {typeof filteredDataListCount === 'number' && filteredDataListCount >= 0 && (
               <div className={classes.cardContainerOuter}>
                  <Typography className={classes.cardOuterTitle}>{filteredDataListCount} jobs found</Typography>
                  <div className={classes.cardContainer}>
                     {filteredDataList &&
                        filteredDataList.length > 0 &&
                        filteredDataList.map(item => (
                           <div className={classes.card}>
                              <Typography className={classes.cardTitle}>{item.name || ''}</Typography>
                              <div className={classes.cardAlignment}>
                                 <img src={icon7} alt="icon" loading="lazy" className={classes.icon} />
                                 <Typography className={classes.cardText}>
                                    {item && Array.isArray(item.jobRole) && item.jobRole.length > 0 && item.jobRole[0].name ? item.jobRole[0].name : ''}
                                 </Typography>
                              </div>
                              <div className={classes.cardAlignment}>
                                 <img src={icon8} alt="icon" loading="lazy" className={classes.icon} />
                                 <Typography className={classes.cardText}>
                                    {item && Array.isArray(item.locationType) && item.locationType.length > 0 && item.locationType[0].name
                                       ? item.locationType[0].name
                                       : ''}
                                 </Typography>
                              </div>
                              <div className={classes.cardAlignment}>
                                 <img src={icon9} alt="icon" loading="lazy" className={classes.icon} />
                                 <Typography className={classes.cardText}>
                                    {item && Array.isArray(item.industryType) && item.industryType.length > 0 && item.industryType[0].name
                                       ? item.industryType[0].name
                                       : ''}
                                 </Typography>
                              </div>
                              <div className={classes.cardAlignment}>
                                 <img src={icon9} alt="icon" loading="lazy" className={classes.icon} />
                                 <Typography className={classes.cardText}>{item.agencyName || ''}</Typography>
                              </div>
                              <Typography className={classes.viewdetailbtn} onClick={() => handleOnJobView(item)}>
                                 View Details <img src={Arrow_icon} alt="icon" loading="lazy" className={classes.icon} />
                              </Typography>
                              <div className={classes.salaryContainer}>
                                 <Typography className={classes.cardText}>
                                    <span>£{item.jobRate || ''}</span>
                                    <br />
                                    /&nbsp;
                                    {item && Array.isArray(item.jobSalaryInterval) && item.jobSalaryInterval.length > 0 && item.jobSalaryInterval[0].label
                                       ? item.jobSalaryInterval[0].label
                                       : ''}
                                 </Typography>
                                 <Button className={classes.applyButton} onClick={() => handleOnJobsRedirect(item)}>
                                    Apply
                                 </Button>
                              </div>
                           </div>
                        ))}
                  </div>
               </div>
            )}
         </div>
         <Footer />
      </>
   )
}

export default browseJobs
